import ToastMessage from './ToastMessage';

const Plugin = function Plugin(Vue) {
  this.Vue = Vue;
  this.mounted = false;
  this.$root = {};
};

Plugin.prototype.mountIfNotMounted = function mountIfNotMounted() {
  if (this.mounted === true) {
    return;
  }

  this.$root = (() => {
    const ToastMessageConstructor = this.Vue.extend(ToastMessage);
    const node = document.createElement('div');
    document.querySelector('#app').appendChild(node);

    return new ToastMessageConstructor().$mount(node);
  })();

  this.mounted = true;
};

Plugin.prototype.destroy = function destroy() {
  if (this.mounted === true) {
    const elem = this.$root.$el;
    this.$root.$destroy();
    this.$root.$off();
    elem.remove();
    this.mounted = false;
  }
};

Plugin.prototype.info = function info(message, bottom, direction, timeout) {
  this.mountIfNotMounted();
  this.$root.open(message, bottom, direction, timeout);
};

Plugin.prototype.close = function close() {
  if (!this.mounted || !this.$root.show) return;

  this.$root.close();
};

Plugin.install = function install(vue, options) {
  const Vue = vue;
  Vue.ToastMessage = new Plugin(Vue, options);
  Vue.prototype.$toastMessage = Vue.ToastMessage;
};

export default Plugin;
